.root {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  width: 100%;
  text-align: start;
  padding: var(--space-4);
  border: 0;
  border-radius: var(--shape-md);
  background: var(--md-surface-container-lowest);
  box-shadow: var(--elevation-1);
  color: var(--md-on-surface);
  margin-block-end: var(--space-2);
  font: inherit;
  cursor: pointer;
  transition: box-shadow var(--motion-duration-short3)
      var(--motion-easing-standard),
    transform var(--motion-duration-short3) var(--motion-easing-standard);
  text-decoration: none;
  position: relative;
  overflow: hidden;
  isolation: isolate;
}

/* State layer overlay */
.root::after {
  content: "";
  position: absolute;
  inset: 0;
  z-index: -1;
  background: currentColor;
  opacity: 0;
  transition: opacity var(--motion-duration-short3)
    var(--motion-easing-standard);
  pointer-events: none;
}

@media (hover: hover) {
  .root:hover {
    box-shadow: var(--elevation-2);
    transform: translateY(-1px);
  }

  .root:hover::after {
    opacity: var(--state-hover);
  }
}

.root:active::after {
  opacity: var(--state-pressed);
}

.icon {
  width: 38px;
  height: 38px;
  border-radius: var(--shape-sm);
  display: grid;
  place-items: center;
  flex-shrink: 0;
  background: var(--md-secondary-container);
  color: var(--md-on-secondary-container);
}

.iconSvg {
  width: 20px;
  height: 20px;
}

.text {
  flex: 1;
  min-width: 0;
}

.title {
  font-weight: 600;
}

.arrow {
  margin-inline-start: auto;
  color: var(--md-on-surface-variant);
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}
